import { render, staticRenderFns } from "./AuctionCom.vue?vue&type=template&id=1f384e57&scoped=true&"
import script from "./AuctionCom.vue?vue&type=script&lang=js&"
export * from "./AuctionCom.vue?vue&type=script&lang=js&"
import style0 from "./AuctionCom.vue?vue&type=style&index=0&id=1f384e57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f384e57",
  null
  
)

export default component.exports